import { timetableTourSteps, ViewTimetable } from '@modules/timetable';
import {
  TIMETABLE_ITEMS_FOR_STUDENT_VIEW,
  timetable_items_for_student_viewSubscription,
  timetable_items_for_student_viewSubscriptionVariables,
} from '@app-types/graphql-types';
import { useSubscription } from '@apollo/client';
import { TimetableCalendarItem } from '@app-types/timetable';
import moment from 'moment';
import { AppTours } from '@modules/app';
import { useMst } from '@models/Root';

export const StudentViewTimetable = () => {
  const {
    student: { firebaseUID },
  } = useMst();

  const { data: timetableViewData, loading: timetableDataLoading } = useSubscription<
    timetable_items_for_student_viewSubscription,
    timetable_items_for_student_viewSubscriptionVariables
  >(TIMETABLE_ITEMS_FOR_STUDENT_VIEW, {
    fetchPolicy: 'no-cache',
    variables: {
      where: {
        studentFirebaseUID: { _eq: firebaseUID },
      },
    },
  });

  // set timetable data
  const timetableCalendarItems: TimetableCalendarItem[] | undefined = timetableViewData?.student_timetable_item.map(
    (timetableItem) => ({
      title: timetableItem.subjectCode,
      subject: timetableItem.subjectName,
      start: moment(timetableItem.startTime).toDate(),
      end: moment(timetableItem.endTime).toDate(),
      batch: timetableItem.batchName,
      location: timetableItem.locationName,
      color: timetableItem.subjectColor,
      lecturer: `${timetableItem.lecturerFirstName} ${timetableItem.lecturerLastName}`,
    }),
  );

  return (
    <>
      <AppTours steps={timetableTourSteps.studentViewTimetable} />

      <ViewTimetable timetableCalendarItems={timetableCalendarItems} timetableDataLoading={timetableDataLoading} />
    </>
  );
};
